import AnimatedTitle from './animatedtitle';

export default AnimatedTitle;
